export class EmitterConstants {
  static INPUT_TRIAL_CODE = 'INPUT_TRIAL_CODE';
  static BACK_PRESSED = 'BACK_PRESSED';
  static OPEN_CONDITIONAL_MODAL = 'OPEN_CONDITIONAL_MODAL';
  static OPEN_INPUT_TRIAL_CODE_MODAL = 'OPEN_INPUT_TRIAL_CODE_MODAL';
  static OPEN_TRIAL_SUCCESS_MODAL = 'OPEN_TRIAL_SUCCESS_MODAL';
  static OPEN_TRIAL_COMPARISON_MODAL = 'OPEN_TRIAL_COMPARISON_MODAL';
  static DOWNGRADE_PACK_IS_TRIAL = 'DOWNGRADE_PACK_IS_TRIAL';
  static OPEN_TRIAL_ACTIVATION_TIMEOUT = 'OPEN_TRIAL_ACTIVATION_TIMEOUT';
  static OPEN_TRIAL_MAX_ATTEMPTS_REACHED_MODAL = 'OPEN_TRIAL_MAX_ATTEMPTS_REACHED_MODAL';
  static BACK_PRESSED_ON_VIDEO = 'BACK_PRESSED_ON_VIDEO';
}
